import { Injectable } from '@angular/core';
import { I18nService } from '@yourcause/common/i18n';
import { NotifierService } from '@yourcause/common/notifier';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';
import { EmailCommunicationResources } from './email-communication.resources';
import { EmailCommunicationState } from './email-communication.state';


@AttachYCState(EmailCommunicationState)
@Injectable({
  providedIn: 'root'
})
export class EmailCommunicationService extends BaseYCService<EmailCommunicationState> {

  constructor (
    private notifier: NotifierService,
    private emailCommunicationResources: EmailCommunicationResources,
    private i18n: I18nService
  ) {
    super();
  }

  get currentUnsubscribedEmailClassIds () {
    return this.get('currentUnsubscribedEmailClassIds');
  }

  get email () {
    return this.get('email');
  }

  setCurrentUnsubscribedEmailClassIds (unsubscribedEmailClassIds: number[]) {
    this.set('currentUnsubscribedEmailClassIds', unsubscribedEmailClassIds);
  }

  setEmail (email: string) {
    this.set('email', email);
  }

  async getEmailCommunicationPreferences (force = false) {
    if (force || !this.currentUnsubscribedEmailClassIds || !this.email) {
      const response = await this.emailCommunicationResources.getEmailCommunicationPreferences();
      this.setCurrentUnsubscribedEmailClassIds(response?.unsubscribedEmailClassIds);
      this.setEmail(response?.email);
    }
  }

  async getUserEmailCommunicationPrefsAsYcAdmin (
    userEmailAddress: string
  ) {
    const response = await this.emailCommunicationResources
      .getEmailCommunicationPreferences(userEmailAddress);
    this.setCurrentUnsubscribedEmailClassIds(response?.unsubscribedEmailClassIds);
    this.setEmail(userEmailAddress);
  }

  async updateEmailCommunicationPreferences (
    emailIdArray: number[],
    userEmailAddress?: string
  ) {
    userEmailAddress = userEmailAddress || null;
    const payload = {
      unsubscribedEmailClassIds: emailIdArray,
      userEmailAddress
    };
    try {
      await this.emailCommunicationResources.updateEmailCommunicationPreferences(
        payload
      );
      if (!!userEmailAddress) {
        this.notifier.success(this.i18n.translate(
          'account:notificationSuccessUpdatingUserCommPrefs',
          {},
          'Successfully updated user email communication preferences'
        ));
      } else {
        this.notifier.success(this.i18n.translate(
          'account:notificationSuccessUpdatingCommPrefs',
          {},
          'Successfully updated your email communication preferences'
        ));
      }
      if (!userEmailAddress) {
        this.setCurrentUnsubscribedEmailClassIds(emailIdArray);
      }
    } catch (e) {
      console.error(e);
      this.notifier.error(this.i18n.translate(
        'account:notificationErrorUpdatingCommPrefs',
        {},
        'There was an error updating your email communication preferences'
      ));
    }
  }
}
